import React from "react";

const LogoGGD = ({ height = "45px" }) => {
  return (
    <svg
      style={{ height }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 366.1 79.4"
      title="Go Get Doc"
    >
      <path
        fill="#006241"
        d="M33.7 42v-6.7h11v22.9c0 6.2-1.8 11.3-5.5 15.2-3.7 3.9-8.8 5.9-15.4 5.9-4.3 0-7.9-.6-11.1-1.7.5-.4 1-.8 1.4-1.2 1.9-1.9 3-4.5 3-7.3v-.5c1.7.8 3.8 1.2 6.3 1.2 2.9 0 5.4-1 7.3-2.9 2-1.9 2.9-4.8 2.9-8.7V42z"
      />
      <path
        fill="#006241"
        d="M55.8 52.3c-4.2-4.1-6.3-9.5-6.3-16.2 0-6.7 2.1-12.1 6.4-16.1 4.3-4.1 9.6-6.1 16-6.1 6.3 0 11.7 2 16 6.1 4.3 4.1 6.4 9.5 6.4 16.1 0 6.7-2.2 12.1-6.5 16.2s-9.7 6.2-16 6.2c-6.3 0-11.8-2.1-16-6.2m15.9-3.1c3.1 0 5.7-1.1 8-3.4 2.2-2.3 3.3-5.5 3.3-9.6 0-4.2-1.1-7.4-3.3-9.6-2.2-2.2-4.8-3.4-8-3.4-3.1 0-5.7 1.1-7.9 3.4-2.1 2.2-3.2 5.5-3.2 9.6 0 4.2 1.1 7.4 3.2 9.6 2.1 2.2 4.8 3.4 7.9 3.4z"
      />
      <path
        fill="#006241"
        d="M129.5 45.5c2.3-2.3 3.4-5.4 3.4-9.4s-1.1-7.1-3.4-9.4c-2.3-2.3-5-3.4-8.1-3.4-3.1 0-5.8 1.1-8 3.4-2.3 2.2-3.4 5.4-3.4 9.3 0 4 1.1 7.1 3.4 9.4 2.3 2.3 5 3.4 8 3.4 3.1.1 5.8-1 8.1-3.3m-24.9 6.7c-3.9-4.2-5.8-9.6-5.8-16.1 0-6.5 1.9-11.9 5.8-16 3.9-4.2 8.8-6.2 14.7-6.2 5.9 0 10.5 2.5 13.6 7.4v-6.7h11v43.7c0 6.2-1.8 11.3-5.5 15.2-3.7 3.9-8.8 5.9-15.4 5.9s-11.9-1.4-15.8-4.1c-3.9-2.7-6.1-6.6-6.6-11.7h10.8c.7 1.9 2 3.5 3.9 4.6 1.9 1.1 4.4 1.7 7.3 1.7 2.9 0 5.4-1 7.3-2.9 2-1.9 2.9-4.8 2.9-8.7v-7.7c-3.3 5.3-7.9 7.9-13.7 7.9-5.7 0-10.6-2.1-14.5-6.3z"
      />
      <path
        fill="#006241"
        d="M180.9 32.6c-.2-2.9-1.2-5.2-3.2-6.9-2-1.7-4.3-2.6-7.1-2.6s-5.1.9-6.9 2.6c-1.9 1.7-3 4-3.3 6.9zm-10.4 25.9c-6.3 0-11.5-2.1-15.4-6.2-4-4.1-6-9.5-6-16.3 0-6.7 2-12.1 6-16.2 4-4 9.2-6.1 15.5-6.1 6.3 0 11.6 2 15.6 5.9 4.1 3.9 6.1 9.2 6.1 15.8 0 1.5-.1 2.9-.3 4.2h-31.7c.3 2.8 1.3 5.1 3.1 6.8 1.8 1.7 4.2 2.6 7 2.6 3.8 0 6.6-1.6 8.5-4.7h11.9c-1.3 4.1-3.7 7.5-7.3 10.1-3.5 2.8-7.9 4.1-13 4.1z"
      />
      <path
        fill="#006241"
        d="M215.4 48.6h5.3v9.2h-7c-4.4 0-7.9-1-10.3-3.1-2.4-2-3.6-5.4-3.6-10.1V23.4h-4.7v-9h4.6V3.7h11.1v10.7h9.7v9h-9.7v21.2c0 1.4.3 2.4 1 3 .7.7 1.9 1 3.6 1"
      />
      <path
        fill="#006241"
        d="M230.7 52.2c-3.9-4.2-5.8-9.6-5.8-16.1 0-6.5 1.9-11.9 5.8-16 3.9-4.2 8.8-6.2 14.7-6.2 6 0 10.5 2.5 13.6 7.4V0h11v58h-11v-7.4c-3.3 5.3-7.9 7.9-13.7 7.9-5.9 0-10.7-2.1-14.6-6.3m24.9-6.7c2.3-2.3 3.4-5.4 3.4-9.4s-1.1-7.1-3.4-9.4c-2.3-2.3-5-3.4-8.1-3.4-3.1 0-5.8 1.1-8 3.4-2.3 2.2-3.4 5.4-3.4 9.3 0 4 1.1 7.1 3.4 9.4 2.3 2.3 5 3.4 8 3.4 3.1.1 5.8-1 8.1-3.3z"
      />
      <path
        fill="#006241"
        d="M281.5 52.3c-4.2-4.1-6.3-9.5-6.3-16.2 0-6.7 2.1-12.1 6.4-16.1 4.3-4.1 9.6-6.1 16-6.1 6.3 0 11.7 2 16 6.1 4.3 4.1 6.4 9.5 6.4 16.1 0 6.7-2.2 12.1-6.5 16.2s-9.7 6.2-16 6.2c-6.4 0-11.7-2.1-16-6.2m15.9-3.1c3.1 0 5.7-1.1 8-3.4 2.2-2.3 3.3-5.5 3.3-9.6 0-4.2-1.1-7.4-3.3-9.6-2.2-2.2-4.8-3.4-8-3.4s-5.7 1.1-7.9 3.4c-2.1 2.2-3.2 5.5-3.2 9.6 0 4.2 1.1 7.4 3.2 9.6 2.1 2.2 4.9 3.4 7.9 3.4z"
      />
      <path
        fill="#006241"
        d="M330.4 52.4c-4-4.1-6-9.5-6-16.2 0-6.7 2-12.1 6-16.2s9.1-6.1 15.4-6.1c5.3 0 9.7 1.3 13.2 3.8 3.6 2.6 5.9 6.2 7.1 10.9h-11.9c-1.4-3.6-4.2-5.4-8.5-5.4-3.2 0-5.7 1.2-7.5 3.5-1.8 2.3-2.7 5.5-2.7 9.5s.9 7.2 2.7 9.5c1.8 2.3 4.3 3.5 7.5 3.5 4.2 0 7-1.8 8.5-5.5h11.9c-1.3 4.5-3.7 8.2-7.3 10.8-3.6 2.7-8 4-13.1 4-6.2 0-11.3-2-15.3-6.1"
      />
      <path
        fill="#006241"
        d="M23.6 23.2h-1.3c-3.1 0-5.7 1.1-7.9 3.4-2.1 2.2-3.2 5.5-3.2 9.6 0 2.2.3 4.1.9 5.8l-7.9 7.9C1.4 46.2 0 41.6 0 36.1 0 29.4 2.1 24 6.4 20c4.3-4.1 9.6-6.1 16-6.1h1.2V8.5l6.1 4.9 6.1 4.9-6.1 4.9-6.1 4.9z"
      />
      <path
        fill="#006241"
        d="M22.3 49.2c3.1 0 5.7-1.1 8-3.4 2.2-2.3 3.3-5.5 3.3-9.6 0-3.3-.7-6-2.1-8.1l7.5-7.5c3.9 4 5.8 9.2 5.8 15.5 0 6.7-2.2 12.1-6.5 16.2s-9.7 6.2-16 6.2c-6.2 0-11.3-1.9-15.5-5.8l7.3-7.3c.1.1.2.3.4.4 2.1 2.2 4.7 3.4 7.8 3.4"
      />
      <path
        d="M6.8 62.3c3.8 0 6.8 3.1 6.8 6.8 0 3.8-3.1 6.8-6.8 6.8C3 75.9 0 72.8 0 69.1c0-3.8 3.1-6.8 6.8-6.8"
        fill="#006241"
      />
    </svg>
  );
};

export { LogoGGD };
